import { IAvatar } from "../container/MySetting/types";
import { ITeamForm, TeamInitialState } from "../types";

export const defaultAvatar: IAvatar = {
  fileId: "",
  icon: "",
  color: "",
  file: "",
  _id: "",
};
export const defaultTeamForm: ITeamForm = {
  _id: "",
  members: [],
  teamName: "",
  owner: "",
  status: [],
  creationDate: "",
  plan: { _id: "", title: "" },
  storageUsedGB: 0,
  storageLimitGB: 0,
  avatar: { ...defaultAvatar },
};

export const initialState: TeamInitialState = {
  loading: false,
  error: null,
  teamForm: { ...defaultTeamForm },
  buttonLoading: false,
};
